import routerOptions0 from "/root/workspace/easygif-nuxt_6hOg/node_modules/.pnpm/nuxt@3.17.5_@parcel+watcher@2.5.1_@types+node@24.0.1_better-sqlite3@11.10.0_db0@0.3.2_b_9b0eeaa8823e70b8b9d9a095eba5f84f/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}